import CryptoJS from 'crypto-js';

export const EncryptionPassword =
  "7b67ff8e6a67b866d898a128fe199da657d197107f2f2c4dfc6187cc61fabb4d";

async function encrypt(text: string, password: string): Promise<string> {
  const iv = CryptoJS.lib.WordArray.random(16);
  const key = CryptoJS.SHA256(password).toString(CryptoJS.enc.Base64);

  const encrypted = CryptoJS.AES.encrypt(text, CryptoJS.enc.Base64.parse(key), {
    iv: iv,
  });

  const result = iv.toString(CryptoJS.enc.Base64) + encrypted.toString();
  return result;
}

export async function encryptObject(obj: any, password: string): Promise<string> {
  const text = JSON.stringify(obj);
  return encrypt(text, password);
}